
import React from 'react'

function Service() {
  return (
    <>
        <section className="bg-half-170 bg-light d-table w-100">
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-lg-12 text-center">
                        <div className="pages-heading">
                            <h4 className="title mb-0"> Үйл ажиллагаа </h4>
                        </div>
                    </div>
                </div>
                
                <div className="position-breadcrumb">
                    <nav aria-label="breadcrumb" className="d-inline-block">
                        <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                            <li className="breadcrumb-item"><a href="/">Эхлэл</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Үйл ажиллагаа</li>
                        </ul>
                    </nav>
                </div>
            </div> 
        </section>
       

        
        <div className="position-relative">
            <div className="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        
        <section className="section">
            <div className="container">
                <div className="row">
                    
                    <div className="col-md-6 col-12 mt-5 pt-4">
                        <div className="features feature-primary">
                            <div className="image position-relative d-inline-block">
                                <i className="uil uil-file-search-alt h2 text-primary"></i>
                            </div>

                            <div className="content mt-4">
                                <h5>Шинжлэх ухаан, технологийн судалгаа хөгжүүлэлт</h5>
                                <p className="text-muted mb-0">• Уул уурхайн салбарын тулгамдсан асуудлыг судалж, эрдэм шинжилгээний үндэслэлтэй шийдлүүд боловсруулах</p>
                                <p className="text-muted mb-0">• Үйлдвэрлэлийн өртөг зардлыг бууруулах судалгааг их өгөгдөл, статистик, шинжлэх ухааны аргачлалд тулгуурлан гүйцэтгэх</p>
                                <p className="text-muted mb-0">• Стратегийн орд газрын эрх зүй, бодлогын судалгаа хийж, олон улсын туршлагад нийцсэн зөвлөмж боловсруулах</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6 col-12 mt-5 pt-4">
                        <div className="features feature-primary">
                            <div className="image position-relative d-inline-block">
                                <i className="uil uil-vector-square h2 text-primary"></i>
                            </div>

                            <div className="content mt-4">
                                <h5>Инноваци ба дижитал шилжилт</h5>
                                <p className="text-muted mb-0">• Ухаалаг технологи, автоматжуулалт, хиймэл оюун ухаан, машин сургалтын шийдлүүдийг уурхайн нөхцөлд тохируулан нэвтрүүлэх</p>
                                <p className="text-muted mb-0">• Төлөвлөлт, хяналт, тайлагналын нэгдсэн диспетчерийн систем боловсруулах</p>
                                <p className="text-muted mb-0">• Хүний нөөцийн чадавхийг үнэлэх, хөгжүүлэх систем бий болгох</p>
                                <p className="text-muted mb-0">• Худалдан авалтын оновчтой сүлжээ, нэгдсэн платформ бий болгох</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-12 mt-5 pt-4">
                        <div className="features feature-primary">
                            <div className="image position-relative d-inline-block">
                                <i className="uil uil-airplay h2 text-primary"></i>
                            </div>

                            <div className="content mt-4">
                                <h5>Бодлогын зөвлөмж, зөвлөх үйлчилгээ</h5>
                                <p className="text-muted mb-0">• Уул уурхайн салбарын хувийн хэвшилд тулгамдаж буй асуудалд бодлогын зөвлөмж, зөвлөх үйлчилгээ үзүүлэх</p>
                                <p className="text-muted mb-0">• Тусгай зөвшөөрөл, үйл ажиллагааны үе шатуудын нарийвчилсан стратеги боловсруулах, зөвлөх үйлчилгээ үзүүлэх</p>
                                <p className="text-muted mb-0">• Төслийн хугацааны төлөвлөлтийн боловсруулалт, зөвлөмж, сургалтын үйлчилгээ үзүүлэх</p>
                                
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6 col-12 mt-5 pt-4">
                        <div className="features feature-primary">
                            <div className="image position-relative d-inline-block">
                                <i className="uil uil-calendar-alt h2 text-primary"></i>
                            </div>

                            <div className="content mt-4">
                                <h5>Сургалт ба мэдлэгийн менежмент</h5>
                                <p className="text-muted mb-0">• Уул уурхайн бодлого, технологи, инновацийн чиглэлээр мэргэжлийн сургалт зохион байгуулах</p>
                                <p className="text-muted mb-0">• Олон улсын туршлага, шинэ технологийг танилцуулах, туршлага хуваалцах семинар, уулзалт хийх</p>
                                <p className="text-muted mb-0">• ESG (байгаль орчин, нийгэм, засаглал), автоматжуулалт, хиймэл оюун ухааны практик сургалт</p>


                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

           {/*  <div className="container mt-3">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Үнийн санал</h4>
                            <p className="text-muted para-desc mb-0 mx-auto">Start working with that can provide everything you need to generate awareness, drive traffic, connect.</p>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center">
                    <div className="col-md-4 col-12 mt-4 pt-2">
                        <div className="card pricing pricing-primary business-rate shadow bg-light rounded text-center border-0">
                            <div className="card-body py-5">
                                <h6 className="title name fw-bold text-uppercase mb-4">Free</h6>
                                <div className="d-flex justify-content-center mb-4">
                                    <span className="h4 mb-0 mt-2">$</span>
                                    <span className="price h1 mb-0">0</span>
                                    <span className="h4 align-self-end mb-1">/mo</span>
                                </div>
                                
                                <ul className="list-unstyled mb-0 ps-0">
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Full Access</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Enhanced Security</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Source Files</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>1 Domain Free</li>
                                </ul>
                                <a href="javascript:void(0)" className="btn btn-primary mt-4">Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-12 mt-4 pt-2">
                        <div className="card pricing pricing-primary business-rate shadow bg-light rounded text-center border-0">
                            <div className="ribbon ribbon-right ribbon-warning overflow-hidden"><span className="text-center d-block shadow small h6">Best</span></div>
                            <div className="card-body py-5">
                                <h6 className="title name fw-bold text-uppercase mb-4">Starter</h6>
                                <div className="d-flex justify-content-center mb-4">
                                    <span className="h4 mb-0 mt-2">$</span>
                                    <span className="price h1 mb-0">39</span>
                                    <span className="h4 align-self-end mb-1">/mo</span>
                                </div>

                                <ul className="list-unstyled mb-0 ps-0">
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Full Access</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Source Files</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Free Appointments</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Free Installment</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Enhanced Security</li>
                                </ul>
                                <a href="javascript:void(0)" className="btn btn-primary mt-4">Get Started</a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-12 mt-4 pt-2">
                        <div className="card pricing pricing-primary business-rate shadow bg-light rounded text-center border-0">
                            <div className="card-body py-5">
                                <h6 className="title name fw-bold text-uppercase mb-4">Professional</h6>
                                <div className="d-flex justify-content-center mb-4">
                                    <span className="h4 mb-0 mt-2">$</span>
                                    <span className="price h1 mb-0">59</span>
                                    <span className="h4 align-self-end mb-1">/mo</span>
                                </div>
                                
                                <ul className="list-unstyled mb-0 ps-0">
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Full Access</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Enhanced Security</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Source Files</li>
                                    <li className="h6 text-muted mb-0"><span className="icon h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>1 Domain Free</li>
                                </ul>
                                <a href="javascript:void(0)" className="btn btn-primary mt-4">Try It Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


        </section>
        

    </>
  )
}

export default Service